import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useTheme } from "../shared/ThemeProvider";
import AnimatedTitle from "../shared/AnimatedTitle";

import review1 from "../../assets/images/review1.jpg";
import review2 from "../../assets/images/review2.jpg";
import review3 from "../../assets/images/review3.jpg";
import review4 from "../../assets/images/review4.jpg";
import review5 from "../../assets/images/review5.jpg";
import review6 from "../../assets/images/review6.jpg";
import review7 from "../../assets/images/review7.jpg";

const testimonials = [
  {
    id: 1,
    image: review1,
    title: "تجربة تعليمية مميزة",
    feedback:
      "كانت الحصة ممتعة وهادفة، والأطفال استمتعوا كثيرًا بأجواء التعلم.",
  },
  {
    id: 2,
    image: review2,
    title: "المعلمة ممتازة",
    feedback: "المعلمة ممتازة جدًا وبتتعامل مع الأطفال بحب وصبر كبير.",
  },
  {
    id: 3,
    image: review3,
    title: "المعلمة مميزة والحصة ممتعة",
    feedback:
      "الحصة كانت أكثر من رائعة، والمعلمة تمتاز بالأسلوب الراقي والتعامل المميز مع الأطفال.",
  },
  {
    id: 4,
    image: review4,
    title: "تحفيز مميز",
    feedback: "طريقة التدريس محفزة جدًا للأطفال.",
  },
  {
    id: 5,
    image: review5,
    title: "أجواء ودية",
    feedback: "الأجواء تعليمية وودية في نفس الوقت.",
  },
  {
    id: 6,
    image: review6,
    title: "حماس للحفظ",
    feedback: "ابني صار يتسابق لحفظ السور قبل موعد الحصة.",
  },
  {
    id: 7,
    image: review7,
    title: "أنصح بها",
    feedback: "التجربة رائعة وأنصح الجميع بها.",
  },
];

const ParentsFeedbackSection = () => {
  const theme = useTheme();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setCardsPerView(1);
      else if (window.innerWidth < 992) setCardsPerView(2);
      else setCardsPerView(3);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const prevSlide = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const visibleCards = [];
  for (let i = 0; i < cardsPerView; i++) {
    const idx = (currentIndex + i) % testimonials.length;
    visibleCards.push(testimonials[idx]);
  }

  return (
    <section
      style={{
        backgroundColor: theme.light,
        padding: "60px 0",
        direction: "rtl",
        textAlign: "center",
      }}
    >
      <Container>
        <AnimatedTitle level={2}>آراء أولياء الأمور</AnimatedTitle>

        <div className="d-flex justify-content-center flex-wrap">
          {visibleCards.map((t) => (
            <div
              key={t.id}
              style={{
                width: `${100 / cardsPerView - 2}%`,
                margin: "10px",
                background: "#fff",
                borderRadius: "20px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                padding: "20px",
                minHeight: "400px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                transition: "all 0.5s",
              }}
            >
              <div
                style={{
                  width: "100%",
                  aspectRatio: "16/9",
                  overflow: "hidden",
                  border: `1px solid ${theme.primary}`,
                  borderRadius: "12px",
                  marginBottom: "15px",
                }}
              >
                <img
                  src={t.image}
                  alt={`testimonial-${t.id}`}
                  style={{ width: "100%", height: "100%", objectFit: "fill" }}
                />
              </div>
              <h5 style={{ color: theme.text, fontWeight: "700" }}>
                {t.title}
              </h5>
              <p style={{ color: "#666" }}>{t.feedback}</p>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center mt-4 gap-3">
          <button
            onClick={prevSlide}
            style={{
              background: theme.primary,
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            ‹
          </button>
          <button
            onClick={nextSlide}
            style={{
              background: theme.primary,
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            ›
          </button>
        </div>
      </Container>
    </section>
  );
};

export default ParentsFeedbackSection;
